// extracted by mini-css-extract-plugin
export default {"cardTypography":"RecipientItem_cardTypography__Z86tj","recipientHeader":"RecipientItem_recipientHeader__tnbqm","editRecipient":"RecipientItem_editRecipient__vGrsr"};